import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Carousel from 'nuka-carousel'
import Link from 'next/link'

import styles from './general.module.scss'
import Button from '../button'
import PoolSvg from '../svg/Pool.svg'
import YogaSvg from '../svg/Yoga.svg'
import SpaSvg from '../svg/Spa.svg'
import GymSvg from '../svg/Gym.svg'
import GolfSvg from '../svg/Golf.svg'
import Chevron from '../svg/Chevron.svg'
import LogoSmall from '../svg/LogoSmall.svg'
import HeartSvg from '../svg/Heart.svg'
import HeartActiveSvg from '../svg/HeartActive.svg'
import DiamondSvg from '../svg/Diamond.svg'
import NWSvg from '../svg/NW.svg'
import ReactMarkdown from 'react-markdown'
import ApiContext from '../../utils/api-context'
import { formatAmountForDisplay } from '../../utils/stripe-helpers'
import { CurrencyContext } from '../../lib/context/CurrencyContext'
import { SettingsContext } from '../../lib/context/SettingsContext'
import { SearchContext } from '../../lib/context/search-context'
import moment from 'moment'
import ClockSvg from '../svg/Clock.svg'
import UserSvg from '../svg/User.svg'

const OfferCard = (props) => {
  const { gallery, small, offer } = props
  const { apiUrl, cdnUrl } = useContext(ApiContext)
  const { currency } = useContext(CurrencyContext)
  const { settings } = useContext(SettingsContext)
  const { searchParams, setSearchParameters } = useContext(SearchContext)
  const calculatePrice = () => {
    let basePrice = 0
    if (offer.packageRooms && offer.packageRooms.length > 0) {
      for (const room of offer.packageRooms) {
        room.rates.forEach((rate) => {
          if (
            moment(searchParams.checkinDate) >=
              moment(`${rate.startDate} 00:00:00`) &&
            moment(searchParams.checkinDate) <=
              moment(`${rate.endDate} 00:00:00`)
          ) {
            if (
              basePrice === 0 ||
              basePrice > offer.fromPrice + rate.adults + rate.children
            ) {
              basePrice = offer.fromPrice + rate.adults + rate.children
            }
          }
        })
      }
    }
    return basePrice > 0 ? basePrice : offer.fromPrice
  }
  return (
    <div
      className={`${styles.card} ${styles.offer}
      ${props.hasOwnProperty('gallery') ? styles.gallery : ''}
      ${props.hasOwnProperty('small') ? styles.small : ''}`}
    >
      <div className={styles.favouriteTag}>
        From{' '}
        <span className={styles.favouritePrice}>
          {formatAmountForDisplay(
            calculatePrice(),
            currency,
            settings.exchangeRate
          )}
        </span>
      </div>
      {!gallery && (
        <div className={styles.image}>
          <img src={`${offer.featuredImage.url}`} alt="" />
        </div>
      )}
      {gallery && (
        <div className={styles.gallery}>
          <div className={styles.tag}>
            <span className={styles.tagNumber}>2</span> Offers
          </div>
          <Carousel
            slidesToScroll={1}
            slidesToShow={1}
            renderCenterLeftControls={({ previousSlide }) => (
              <button className={styles.chevronLeft} onClick={previousSlide}>
                <Chevron />
              </button>
            )}
            renderCenterRightControls={({ nextSlide }) => (
              <button className={styles.chevronRight} onClick={nextSlide}>
                <Chevron />
              </button>
            )}
            enableKeyboardControls
            cellSpacing={2}
          >
            <div className={styles.image}>
              <img
                src="/static/images/placeholders/inspiration-hero.jpg"
                alt=""
              />
            </div>
            <div className={styles.image}>
              <img
                src="/static/images/placeholders/inspiration-hero.jpg"
                alt=""
              />
            </div>
          </Carousel>
        </div>
      )}
      <div className={styles.inner}>
        <div className={styles.header}>
          <span className={styles.tagline}>{offer.cardTag}</span>
        </div>
        <h2 className="line-clamp-2" title={offer.name}>{offer.name}</h2>
        <p className={styles.clamp}>{offer.cardOverview}</p>
        <div className={styles.properties}>
          {offer.nights && offer.nights !== '' && (
            <>
              <ClockSvg />
              {offer.nights} Nights
            </>
          )}
        </div>
        <div className={styles.footer}>
          <Button
            size="small"
            width="120px"
            color="green"
            href={`/packages/${offer.slug}`}
            className={'cta-event-trigger'}
          >
            Explore
          </Button>
        </div>
      </div>
    </div>
  )
}
OfferCard.propTypes = {
  gallery: PropTypes.bool,
  small: PropTypes.bool,
  offer: PropTypes.object.isRequired,
}
export default OfferCard
